import { render, staticRenderFns } from "./AccessoryTransfer.vue?vue&type=template&id=3f87ad92&scoped=true"
import script from "./AccessoryTransfer.vue?vue&type=script&lang=js"
export * from "./AccessoryTransfer.vue?vue&type=script&lang=js"
import style0 from "./AccessoryTransfer.vue?vue&type=style&index=0&id=3f87ad92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87ad92",
  null
  
)

export default component.exports